/**
 * Ensures Toastify (react-toastify) notices auto-close even when pauseOnHover or app config leave toasts stuck.
 * Set ms before defer load: window.REELYAKS_TOAST_AUTO_HIDE_MS = 5000;
 */
(function () {
  var BASE_MS =
    typeof window.REELYAKS_TOAST_AUTO_HIDE_MS === 'number' && window.REELYAKS_TOAST_AUTO_HIDE_MS >= 1000
      ? window.REELYAKS_TOAST_AUTO_HIDE_MS
      : 5000;

  function dismissToast(el) {
    if (!el || !el.parentNode) return;
    var close = el.querySelector('.Toastify__close-button');
    if (close) {
      close.click();
      return;
    }
    el.remove();
    var tray = document.querySelector('.Toastify__toast-container:empty');
    if (tray) tray.remove();
  }

  function armToast(el) {
    if (!el || !el.classList || !el.classList.contains('Toastify__toast')) return;
    if (el.dataset.reelyaksToastArm === '1') return;
    el.dataset.reelyaksToastArm = '1';

    var ms = BASE_MS;
    var pb = el.querySelector('.Toastify__progress-bar');
    if (pb) {
      pb.style.animationDuration = ms + 'ms';
      pb.style.animationPlayState = 'running';
    }

    window.setTimeout(function () {
      dismissToast(el);
    }, ms + 50);
  }

  function scan() {
    document.querySelectorAll('.Toastify__toast').forEach(armToast);
  }

  scan();

  if (typeof MutationObserver === 'undefined') return;

  var moTimer = null;
  var observer = new MutationObserver(function () {
    if (moTimer) window.clearTimeout(moTimer);
    moTimer = window.setTimeout(function () {
      moTimer = null;
      scan();
    }, 80);
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
    return;
  }

  document.addEventListener(
    'DOMContentLoaded',
    function () {
      if (document.body) observer.observe(document.body, { childList: true, subtree: true });
      scan();
    },
    { once: true }
  );
})();
